import request from '../utils/request'

export function updatePasswordApi(params) {
  return request.post('/api/auth/update_password', params)
}
